import { Link } from "react-router-dom";

function Breadcrumb({name,cat,product,image}) {
    return ( 
        <div className="container-fluid page-header py-5 mb-5" style={{background: image !== '' ? `linear-gradient(rgba(53, 53, 53, .7), rgba(53, 53, 53, .7)),url(${image})` : `linear-gradient(rgba(53, 53, 53, .7), rgba(53, 53, 53, .7)),url(/defaults/theme4/images/carousel-1.jpg)`}}>
            <div className="container py-5 text-center">
                <h1 className="display-3 fw-bold text-white mb-3 animated slideInDown">{name}</h1>
                    <nav aria-label="breadcrumb animated slideInDown">
                        <ol className="breadcrumb">
                            {cat === '' ? <li className="breadcrumb-item text-white">{name}</li> :
                            product !== '' ? <><li className="breadcrumb-item"><Link className="text-white  text-decoration-none" to="/shop">Shop</Link></li><li className="breadcrumb-item text-white">{cat.name}</li><li className="breadcrumb-item text-white">{name}</li></> :
                            <><li className="breadcrumb-item"><Link className="text-white text-decoration-none" to="/shop">{name}</Link></li> <li className="breadcrumb-item text-white">{cat}</li></>}
                        </ol>
                    </nav>
            </div>
        </div>
    );
}

export default Breadcrumb;